import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrButtonModule } from '../pr-button/pr-button.module';
import { PrButtonToggleComponent } from './pr-button-toggle.component';

@NgModule({
  imports: [CommonModule, PrButtonModule],
  exports: [PrButtonToggleComponent],
  declarations: [PrButtonToggleComponent],
})
export class PrButtonToggleModule {}
